/**
 * @description 微信登录
 * @param { Object } params 请求参数
 */
export const loginWechat = (params) => {
  return {
    url: '/api/we-chat/session/v2',
    method: 'get',
    params,
  };
};

/**
 * @description 绑定微信
 * @param { Object } params 请求参数
 */
export const bindWechat = (params) => {
  return {
    url: '/api/we-chat/bind',
    method: 'get',
    params,
  };
};

/**
 * @description 解绑微信
 */
export const unbindWechat = () => {
  return {
    url: '/api/weChat/unbind',
    method: 'get',
  };
};
